import React from 'react';
import styles from './ImageSection.module.css';

const ImageSection = () => {
    return (
        <div className={styles.imageSection}>
            <div className={styles.imageWrapper}>
                <img 
                    src={require('../../../../assets/images/discountOffer/discount_offer_job_seeker.png')}
                    alt="Professional woman in hijab"
                    className={styles.profileImage}
                />
            </div>
            <div className={styles.imageWrapper}>
                <img 
                    src={require('../../../../assets/images/discountOffer/discount_offer_employer.png')}
                    alt="Professional man in traditional dress"
                    className={styles.profileImage}
                />
            </div>
        </div>
    );
};

export default ImageSection; 